<template>
    <div class="sideblock-delivery-point">
        <div class="sideblock-delivery-point__text">
            {{subtitle}}
        </div>
        <div class="sideblock-delivery-point__text" v-if="isCityStreetSearchAvailable">
            <sideblock-delivery-point-dadata-cdek v-on:dadata-result="onDataResult" />
        </div>

        <div class="sideblock-delivery-point__spacer" />

        <div style="width: 64px; height: 64px; margin: 0 auto" v-if="isLoading || (getShippingPriceIsLoading && !isCityStreetSearchAvailable)">
            <ui-loader />
        </div>
        <template v-if="!getShippingPriceIsLoading || isCityStreetSearchAvailable">
            <sideblock-delivery-point-item
                v-for="item in items"
                v-bind:item="item"
                :key="item.uuid"
                class="sideblock-delivery-point__item"
                v-on:select="selectItem(item)"
                />
        </template>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { mainClient } from '~/network';

export default {
    name: 'sideblock-delivery-point',
    data() {
        return {
            items: [],
            isLoading: false,
        };
    },
    mounted() {
        if (!this.isCityStreetSearchAvailable && this.checkoutData.city?.cdek_code) {
            this.loadCdekDeliveryPoints({
                city_code: this.checkoutData.city?.cdek_code,
                limit: 50,
            });
        }
    },
    computed: {
        ...mapGetters('checkout', [ 'customerData' ]),
        ...mapState('shippingMethods', [ 'getShippingPriceIsLoading' ]),
        ...mapState('areas', [ 'getAreasResult' ]),
        currentCity() {
            const currentCountry = this.getAreasResult?.find(area => area.id === this.checkoutData?.country?.id);
            if (currentCountry && this.checkoutData.city) {
                return currentCountry?.children?.find(city => city.id === this.checkoutData.city?.id);
            }
            return null;
        },
        checkoutData() {
            return this.$store.state.checkout.data;
        },
        isCityStreetSearchAvailable() {
            return this.currentCity?.is_dadata_compatible;
        },
        city() {
            return this.customerData.line4 ?? '';
        },
        subtitle() {
            return this.isCityStreetSearchAvailable
                ? 'Укажите ваш адрес и мы предложим ближайшие пункты выдачи'
                : 'Ближайшие пункты выдачи';
        },
    },
    methods: {
        close() {
            this.$store.commit('sideblocks/pop');
        },
        async loadCdekDeliveryPoints(payload) {
            this.isLoading = true;
            try {
                const { data } = await mainClient.shop.getShippingCdekDeliveryPoints(payload);
                this.items = data;
            } catch (e) {
                console.error(e);
            }
            this.isLoading = false;
        },
        onDataResult(r) {
            if (r.postcode) {
                this.loadCdekDeliveryPoints({
                    postal_code: r.postcode,
                    geo_lat: r.geo_lat,
                    geo_lon: r.geo_lon,
                });
            }
        },
        selectItem(pointData) {
            this.$store.commit('checkout/updateData', {
                cdekDeliveryPoint: pointData,
            });
            this.close();
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.sideblock-delivery-point {
    .mixin-sideblock();

    padding: 20px 0 60px;
    &__table {
        margin-bottom: 40px;
        &-item {
            display: flex;
            width: 100%;
            &-column {
                flex: 0 0 auto;
                padding: 28px 20px 24px;
                width: 50%;
                &:first-child:last-child {
                    width: 100%;
                }
                &:first-child:last-child &-text {
                    max-width: 100%;
                }
                &-icon {
                    //height: 4rem;
                    //margin-bottom: 10px;
                    height: 48px;
                    margin-bottom: 16px;
                    padding: 0 20px;
                }
                &-text {
                    max-width: 150px;
                }
            }
        }
    }
    &__title {
        flex: 0 0 auto;
        padding: 0 20px;
        margin-bottom: 8px;

        text-transform: uppercase;
    }
    &__text {
        flex: 0 0 auto;
        padding: 0 20px;
        margin-bottom: 20px;

        &-trigger {
            .mixin-link-decoration();

            cursor: pointer;
        }

        ul {
            padding-left: 26px;
        }
    }
    &__trigger {
        .mixin-link-decoration();

        cursor: pointer;
    }
    &__spacer {
        margin-top: 40px;
    }
    &__line {
        width: 100%;
        border-top: 1px solid @color-gray-darkest;
        margin-bottom: 20px;
    }
    @media @media-sm-down {
        &__table {
            margin-bottom: 40px;
        }
    }

    &__item {
        border-top: 1px solid @color-gray-darkest;

        &:hover,
        &._active {
            background-color: @color-accent-yellow;
        }
        &._active & {
            &-trigger {
                display: none;
            }
            &-check {
                display: block;
            }
        }
    }

}
</style>
